import { AlloyButton } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { isEmpty } from '@app/utils';
import { useDispatch } from 'react-redux';
import { getActiveFacets } from '@app/components/pages/marketing/components/ProductCardGrid/utils';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { activeFacetsPropTypes } from '../SpecificationFacets/declarations.propTypes';

const ProductListFilterBoxes = ({
  activeFacets,
  queryActionParam,
  widgetId,
  setUrlToPageOneWithFilter,
  fbeEnabled
}) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const { hash } = useLocation();

  const { facets: facetsFromHash } = queryString.parse(hash);
  const facetsArray = !Array.isArray(facetsFromHash)
    ? [facetsFromHash]
    : facetsFromHash;
  const {
    orderBy: orderByFromUrl,
    filterByEquipment: filterByEquipmentFromUrl
  } = queryString.parse(hash);
  const updatedOrderBy = orderByFromUrl ? 'orderBy' : 'sortBy';
  const handleClick = facetbox => {
    const updatedActiveFacets = activeFacets.filter(
      ({ facet }) => facet !== facetbox
    );
    dispatch(
      queryActionParam(
        widgetId
          ? {
              widgetId: widgetId,
              data: {
                activeFacets: updatedActiveFacets,
                pageNumber: 1,
                batchPartNumbers: []
              }
            }
          : { activeFacets: updatedActiveFacets },
        true
      )
    );
    if (widgetId) {
      facetsArray.forEach(item => {
        const widgetUrlValue = item.split('|');
        if (widgetUrlValue[0] === facetbox) {
          facetsArray.splice(facetsArray.indexOf(item), 1);
        }
      });
      setUrlToPageOneWithFilter({
        filterByEquipment: filterByEquipmentFromUrl,
        facets: getActiveFacets(facetsArray, updatedActiveFacets, widgetId),
        [updatedOrderBy]: orderByFromUrl,
        isMarketingPage: true,
        fbeEnabledValue: fbeEnabled
      });
    } else {
      setUrlToPageOneWithFilter({
        filterByEquipment: filterByEquipmentFromUrl,
        facets: updatedActiveFacets,
        [updatedOrderBy]: orderByFromUrl
      });
    }
  };

  const clearHandleClick = () => {
    dispatch(
      queryActionParam(
        widgetId
          ? {
              widgetId: widgetId,
              data: {
                activeFacets: [],
                pageNumber: 1,
                batchPartNumbers: []
              }
            }
          : { activeFacets: [] },
        true
      )
    );

    if (widgetId) {
      let activeFacetsWithWidgetId = [];
      activeFacets.forEach(j => {
        activeFacetsWithWidgetId.push(`${j.facet}|${widgetId}`);
      });

      const finalUrlFacets = facetsArray
        .filter(facet => !activeFacetsWithWidgetId.includes(facet))
        .map(item => ({ facet: item }));
      setUrlToPageOneWithFilter({
        filterByEquipment: filterByEquipmentFromUrl,
        facets: finalUrlFacets,
        [updatedOrderBy]: orderByFromUrl,
        isMarketingPage: true,
        fbeEnabledValue: fbeEnabled
      });
    } else {
      setUrlToPageOneWithFilter({
        filterByEquipment: filterByEquipmentFromUrl,
        facets: [],
        [updatedOrderBy]: orderByFromUrl
      });
    }
  };

  return (
    !isEmpty(activeFacets) && (
      <>
        <div className="pb-3">
          {activeFacets.map(({ facet, label, groupLabel = '' }) => {
            return (
              <AlloyButton
                buttonType="chip"
                className="m-1 u-color--Black text-sans-serif u-fs--14"
                key={facet}
                chipLabel={groupLabel}
                onClick={() => handleClick(facet)}
              >
                {label}
              </AlloyButton>
            );
          })}
        </div>
        <AlloyButton
          buttonType="link"
          className="pb-3"
          onClick={clearHandleClick}
        >
          {t('CLEAR_ALL_FILTERS')}
        </AlloyButton>
      </>
    )
  );
};
ProductListFilterBoxes.propTypes = {
  activeFacets: activeFacetsPropTypes,
  queryActionParam: PropTypes.func,
  fbeEnabled: PropTypes.bool,
  widgetId: PropTypes.string,
  setUrlToPageOneWithFilter: PropTypes.func
};
export default ProductListFilterBoxes;
